/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import * as React from 'react';

import { AppModal } from './@types';
import { useQueryParam } from '../navigation';

type ModalActions = Record<AppModal, VoidFunction>;

export function useModal() {
  const [param, setParam, removeParam] = useQueryParam('modal');

  const show = React.useCallback(
    (modal: AppModal) => {
      // in this implementation, modals are not queued. this could be done by e.g. saving the modals and opening in order
      if (param) {
        console.warn('Tried to open a modal with one already open');
        return;
      }
      setParam(modal);
    },
    [setParam, param]
  );

  const modals = React.useMemo(
    () =>
      Object.values(AppModal).reduce((modals, modal) => {
        modals[modal] = () => {
          show(modal);
        };
        return modals;
      }, {} as ModalActions),
    [show]
  );

  return { param, dismiss: removeParam, show, modals };
}
